import { render } from "./BarcodeDeleteDialog.vue?vue&type=template&id=aa06d66a"
import script from "./BarcodeDeleteDialog.vue?vue&type=script&lang=js"
export * from "./BarcodeDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__